import { datadogRum } from '@datadog/browser-rum'
import { useFetchLayer } from '@app/domains/layers/hooks/useFetchLayer'
import { useFetchLegends } from '@app/hooks/useFetchLegends'
import { useFetchSettings } from '@app/hooks/useFetchSettings'
import { useShowToastOnClientChange } from '@app/hooks/useShowToastOnClientChange'
import { userAtom } from '@app/hooks/useUserProfile'
import { useFetchLayerStyles, useFetchPreferences } from '@app/services/legendService'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { getCurrentSubdomain } from '@app/utils/getCurrentSubdomain'

const AppLoaderRefactored = () => {
  const clientName = getCurrentSubdomain(
    window.location.hostname,
    import.meta.env.VITE_SAFE_DOMAIN ?? 'rex.local',
  )
  useFetchLegends()
  useFetchLayer()
  useFetchSettings(clientName ?? '')
  useFetchPreferences()
  useFetchLayerStyles()
  useShowToastOnClientChange()

  const userQuery = useAtomValue(userAtom)
  const userProfile = userQuery.data

  useEffect(() => {
    if (!userProfile?.email) {
      Sentry.setUser(null)
      datadogRum.setUser({})
      return
    }

    Sentry.setUser({ email: userProfile.email })
    datadogRum.setUser({
      id: userProfile.user_uuid,
      email: userProfile.email,
      role: userProfile.user_roles?.join(',') || '',
      client: userProfile.client_name,
    })
  }, [userProfile])

  return null
}

export default AppLoaderRefactored
